module.exports = __webpack_public_path__ + "img/category-brand-hover.bc711b1f.png";